export default __webpack_public_path__ + "static/media/high_five.4ac3ca14.svg";